import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useGetCurrentAccountQuery, useLogoutMutation } from 'features/auth/services';
import { useAuth } from 'hooks/useAuth';
import { useWorkspace } from 'hooks/useWorkspace';
import { useCallback, useState } from 'react';
import { appActions, selectDrawerOpen } from 'store/app-slice';
import { logout } from 'store/auth-slice';

const useController = () => {
    const { openModal } = useWorkspace();
    const dispatch = useAppDispatch();
    const { data, isSuccess } = useGetCurrentAccountQuery();
    const [logoutMutation] = useLogoutMutation();

    const { refreshToken, sessionId } = useAuth();

    const drawerOpen = useAppSelector(selectDrawerOpen);
    const [isChangeWorkspaceOpen, setIsChangeWorkspaceOpen] = useState(openModal);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const { role } = useAuth();
    const isProfileOpen = Boolean(anchorEl);

    const handleOpenProfile = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseProfile = () => {
        setAnchorEl(null);
    };

    const handleDrawerClick = useCallback(() => {
        dispatch(appActions.setDrawerOpen(true));
    }, [dispatch]);

    const handleLogout = useCallback(async () => {
        await logoutMutation({ refreshToken, sessionId });
        dispatch(logout());
    }, [dispatch]);

    const handleOpenChangeWorkspace = useCallback(() => {
        setIsChangeWorkspaceOpen(true);
    }, []);

    const handleCloseChangeWorkspace = useCallback(() => {
        setIsChangeWorkspaceOpen(false);
    }, []);

    return {
        username: data?.username,
        role,
        isSuccess,
        handleDrawerClick,
        handleLogout,
        drawerOpen,
        handleOpenChangeWorkspace,
        handleCloseChangeWorkspace,
        handleOpenProfile,
        handleCloseProfile,
        isChangeWorkspaceOpen,
        isProfileOpen,
        anchorEl,
    };
};

export default useController;
